import { barChartItem } from './barChart';

export const gcpChartItems: barChartItem[] = [
  {
    itemName: 'Compute Engine',
    itemPercentage: 60
  },
  {
    itemName: 'Cloud SQL',
    itemPercentage: 70
  },
  {
    itemName: 'Cloud Storage',
    itemPercentage: 70
  },
  {
    itemName: 'Cloud Load Balancing',
    itemPercentage: 60
  },
  {
    itemName: 'Cloud CDN',
    itemPercentage: 60
  },
  {
    itemName: 'GAE',
    itemPercentage: 80
  },
  {
    itemName: 'Firebase',
    itemPercentage: 70
  },
  {
    itemName: 'Firestore',
    itemPercentage: 70
  },
  {
    itemName: 'Cloud Functions',
    itemPercentage: 60
  },
  {
    itemName: 'BigQuery',
    itemPercentage: 50
  },
];
